export const globalAlertQueryKeys = {
  all: ['global-alerts'] as const,
  summary: () => [...globalAlertQueryKeys.all, 'summary'] as const,
};